// this is a workaround for "parse-i18n-from-file" in build step
// parse-i18n-from-file doesn't support ts types
// this file adds type to messages object
export const messages = {
  search_box_hint: {
    defaultMessage: 'Name, city or zip code',
    id: 'fa.audi-dealer-search.search_box_hint',
  },
  audi_partners_off_search_box_hint: {
    defaultMessage: 'City or zip code',
    id: 'fa.audi-dealer-search.audi_partners_off_search_box_hint',
  },
  two_click_confirm_button: {
    id: 'fa.audi-dealer-search.two_click_confirm_button',
  },
  search_box_placeholder: {
    defaultMessage: 'Search Dealer',
    id: 'fa.audi-dealer-search.search_box_placeholder',
  },
  autocompletion_places: {
    defaultMessage: 'Places',
    id: 'fa.audi-dealer-search.autocompletion_places',
  },
  autocompletion_audi_partner: {
    defaultMessage: 'Audi Partner',
    id: 'fa.audi-dealer-search.autocompletion_audi_partner',
  },
  autocompletion_show_more: {
    defaultMessage: 'show more',
    id: 'fa.audi-dealer-search.autocompletion_show_more',
  },
  search_in_this_area: {
    defaultMessage: 'Search this area',
    id: 'fa.audi-dealer-search.search_in_this_area',
  },
  search_result_description: {
    defaultMessage: '{{resultCount}} Audi partner(s) found',
    id: 'fa.audi-dealer-search.search_result_description',
  },
  search_result_description_with_radius_and_options: {
    defaultMessage: '{{resultCount}} Audi partner(s) within',
    id: 'fa.audi-dealer-search.search_result_description_with_radius',
  },
  search_result_description_with_radius: {
    defaultMessage: '{{resultCount}} Audi partner(s) within {{radius}}',
    id: 'fa.audi-dealer-search.search_result_description_with_radius',
  },
  search_radius: {
    defaultMessage: 'Search radius',
    id: 'fa.audi-dealer-search.search_radius',
  },
  search_result_radius_extended: {
    defaultMessage: 'No partner found within your search radius. Nearest results are shown.',
    id: 'fa.audi-dealer-search.search_result_radius_extended',
  },
  search_result_empty: {
    defaultMessage: 'No results found, please adjust your search query and try again.',
    id: 'fa.audi-dealer-search.search_result_empty',
  },
  filter: {
    defaultMessage: 'Filters',
    id: 'fa.audi-dealer-search.filter',
  },
  filter_show_big_results: {
    defaultMessage: 'Show {{resultCount}} results',
    id: 'fa.audi-dealer-search.filter_show_big_results',
  },
  filter_show_no_result: {
    defaultMessage: '0 results found',
    id: 'fa.audi-dealer-search.filter_show_no_result',
  },
  filter_show_one_result: {
    defaultMessage: 'Show 1 result',
    id: 'fa.audi-dealer-search.filter_show_one_result',
  },
  filter_service: {
    defaultMessage: 'Service',
    id: 'fa.audi-dealer-search.filter_service',
  },
  filter_e_tron: {
    defaultMessage: 'Audi e-tron',
    id: 'fa.audi-dealer-search.filter_e_tron',
  },
  filter_sales_r8: {
    defaultMessage: 'Audi Sport / R8',
    id: 'fa.audi-dealer-search.filter_sales_r8',
  },
  filter_service_r8: {
    defaultMessage: 'Audi Sport / Service R8',
    id: 'fa.audi-dealer-search.filter_service_r8',
  },
  filter_sales_rs: {
    defaultMessage: 'Audi RS',
    id: 'fa.audi-dealer-search.filter_sales_rs',
  },
  filter_usedcars: {
    defaultMessage: 'Audi Approved :plus',
    id: 'fa.audi-dealer-search.filter_usedcars',
  },
  filter_sales: {
    defaultMessage: 'Sales',
    id: 'fa.audi-dealer-search.filter_sales',
  },
  filter_silvercar: {
    defaultMessage: 'Silvercar',
    id: 'fa.audi-dealer-search.filter_silvercar',
  },
  filter_audi_at_your_door: {
    defaultMessage: 'Audi at Your Door',
    id: 'fa.audi-dealer-search.filter_audi_at_your_door',
  },
  filter_damage_specialist: {
    defaultMessage: 'Accident Specialist',
    id: 'fa.audi-dealer-search.filter_damage_specialist',
  },
  filter_audi_on_demand: {
    defaultMessage: 'Audi on Demand',
    id: 'fa.audi-dealer-search.filter_audi_on_demand',
  },
  five_star_ratings: {
    defaultMessage: 'Ratings',
    id: 'fa.audi-dealer-search.five_star_ratings',
  },
  five_star_reviews: {
    defaultMessage: 'Written Reviews',
    id: 'fa.audi-dealer-search.five_star_reviews',
  },
  five_star_average_rating: {
    defaultMessage: 'Average rating',
    id: 'fa.audi-dealer-search.five_star_average_rating',
  },
  five_star_single_star: {
    defaultMessage: 'star',
    id: 'fa.audi-dealer-search.five_star_single_star',
  },
  five_star_plural_star: {
    defaultMessage: 'stars',
    id: 'fa.audi-dealer-search.five_star_plural_star',
  },
  five_star_all_services: {
    defaultMessage: 'All Services',
    id: 'fa.audi-dealer-search.five_star_all_services',
  },
  five_star_sales_category: {
    defaultMessage: 'Sales Category',
    id: 'fa.audi-dealer-search.five_star_sales_category',
  },
  five_star_service_category: {
    defaultMessage: 'Service Category',
    id: 'fa.audi-dealer-search.five_star_service_category',
  },
  five_star_filter_by: {
    defaultMessage: 'Filter by',
    id: 'fa.audi-dealer-search.five_star_filter_by',
  },
  five_star_all_stars: {
    defaultMessage: 'All stars',
    id: 'fa.audi-dealer-search.five_star_all_stars',
  },
  five_star_sort_by: {
    defaultMessage: 'Sort by',
    id: 'fa.audi-dealer-search.five_star_sort_by',
  },
  five_star_newest: {
    defaultMessage: 'Newest',
    id: 'fa.audi-dealer-search.five_star_newest',
  },
  five_star_oldest: {
    defaultMessage: 'Oldest',
    id: 'fa.audi-dealer-search.five_star_oldest',
  },
  five_star_highest: {
    defaultMessage: 'Highest',
    id: 'fa.audi-dealer-search.five_star_highest',
  },
  five_star_lowest: {
    defaultMessage: 'Lowest',
    id: 'fa.audi-dealer-search.five_star_lowest',
  },
  five_star_no_reviews_all: {
    defaultMessage:
      'There are currently no written reviews for this dealership. Please check back frequently.',
    id: 'fa.audi-dealer-search.five_star_no_reviews_all',
  },
  five_star_no_reviews_sales: {
    defaultMessage:
      'There are currently no written reviews for the Sales Category. Please check back frequently.',
    id: 'fa.audi-dealer-search.five_star_no_reviews_sales',
  },
  five_star_no_reviews_service: {
    defaultMessage:
      'There are currently no written reviews for the Service Category. Please check back frequently.',
    id: 'fa.audi-dealer-search.five_star_no_reviews_service',
  },
  five_star_dealer_response: {
    defaultMessage: 'Response from dealer',
    id: 'fa.audi-dealer-search.five_star_dealer_response',
  },
  five_star_read_more: {
    defaultMessage: 'Read more',
    id: 'fa.audi-dealer-search.five_star_read_more',
  },
  five_star_view_more: {
    defaultMessage: 'View more',
    id: 'fa.audi-dealer-search.five_star_view_more',
  },
  five_star_rating_tooltip: {
    defaultMessage:
      'The ratings and average rating count shown are calculated based on customer submitted ratings. In addition, the written reviews listed are provided voluntarily by customers and are not considered part of ratings calculation.',
    id: 'fa.audi-dealer-search.five_star_rating_tooltip',
  },
  five_star_review_tooltip: {
    defaultMessage:
      'Written reviews listed are provided voluntarily by customers and are not considered part of ratings calculation. Reviews may be more infrequent and are separate from ratings.',
    id: 'fa.audi-dealer-search.five_star_review_tooltip',
  },
  show_on_map: {
    defaultMessage: 'Show map',
    id: 'fa.audi-dealer-search.show_on_map',
  },
  show_as_list: {
    defaultMessage: 'Show as a list',
    id: 'fa.audi-dealer-search.show_as_list',
  },
  show_map: {
    defaultMessage: 'map',
    id: 'fa.audi-dealer-search.show_map',
  },
  show_list: {
    defaultMessage: 'Show list',
    id: 'fa.audi-dealer-search.show_list',
  },
  error_message_header: {
    defaultMessage: 'Location cannot be determined',
    id: 'fa.audi-dealer-search.error_message_header',
  },
  error_message_body: {
    defaultMessage: 'The myAudi partner search is not authorized to use your location',
    id: 'fa.audi-dealer-search.error_message_body',
  },
  back_to_results: {
    defaultMessage: 'Back to results',
    id: 'fa.audi-dealer-search.back_to_results',
  },
  load_more_dealers: {
    defaultMessage: 'Load More Dealers ({{numOfDealers}})',
    id: 'fa.audi-dealer-search.load_more_dealers',
  },
  back_to_search: {
    defaultMessage: 'Back to search',
    id: 'fa.audi-dealer-search.back_to_search',
  },
  open_now: {
    defaultMessage: 'Open Now',
    id: 'fa.audi-dealer-search.open_now',
  },
  closed: {
    defaultMessage: 'closed',
    id: 'fa.audi-dealer-search.closed',
  },
  list_view: {
    defaultMessage: 'List View',
    id: 'fa.audi-dealer-search.list_view',
  },
  list_view_empty_result_placeholder: {
    defaultMessage: 'Search by name, city or ZIP code for results to be displayed here.',
    id: 'fa.audi-dealer-search.list_view_empty_result_placeholder',
  },
  map_view: {
    defaultMessage: 'Map View',
    id: 'fa.audi-dealer-search.map_view',
  },
  partner_details: {
    defaultMessage: 'Partner Details',
    id: 'fa.audi-dealer-search.partner_details',
  },
  gps_button_text: {
    defaultMessage: 'Use my current location',
    id: 'fa.audi-dealer-search.gps_button_text',
  },
  place_not_found: {
    defaultMessage:
      'No results found. Make sure your search is spelled correctly by adding a name, city or zip code',
    id: 'fa.audi-dealer-search.place_not_found',
  },
  cookie_consent_button: {
    defaultMessage: 'Cookie-Einstellungen',
    id: 'fa.audi-dealer-search.cookie_consent_button',
  },
  fax: {
    defaultMessage: 'Fax',
    id: 'partnerBusinessCard.fax',
  },
  phone: {
    defaultMessage: 'Phone',
    id: 'partnerBusinessCard.phone',
  },
  directionsLinkLabel: {
    defaultMessage: 'Directions',
    id: 'partnerBusinessCard.directionsLinkLabel',
  },
  vCardLinkLabel: {
    defaultMessage: 'Download contact data',
    id: 'partnerBusinessCard.vCardLinkLabel',
  },
  linkLabel: { defaultMessage: 'More info', id: 'partnerBusinessCard.linkLabel' },
  myAudiLinkLabel: {
    defaudefaultMessagelt: 'Save in myAudi',
    id: 'partnerBusinessCard.myAudiLinkLabel',
  },
  addressAndContactLabel: {
    defaultMessage: 'Address',
    id: 'partnerBusinessCard.addressAndContact.label',
  },
  partnerServiceSales: { defaultMessage: 'Car sales', id: 'service.sales' },
  partnerServiceSalesR8: { defaultMessage: 'Audi Sport', id: 'service.sales-r8' },
  partnerServiceServiceR8: { defaultMessage: 'Service R8', id: 'service.service-r8' },
  partnerServiceService: { defaultMessage: 'Service & maintenance', id: 'service.service' },
  partnerServiceEtron: { defaultMessage: 'Electric', id: 'service.e-tron' },
  partnerServiceUsedcars: {
    defaultMessage: 'Audi Approved Used',
    id: 'service.audi-approved-plus',
  },
  openingHoursHeadline: { defaultMessage: 'Opening hours', id: 'openingHours.headline' },
  openingHoursLabelOpenUntil: { defaultMessage: 'Open until', id: 'openingHours.labelOpenUntil' },
  openingHoursLabelClosesSoon: {
    defaultMessage: 'Closes soon',
    id: 'openingHours.labelClosesSoon',
  },
  openingHoursLabelClosed: { defaultMessage: 'Closed', id: 'openingHours.labelClosed' },
  openingHoursLabelWillOpenAt: { defaultMessage: 'Opens', id: 'openingHours.labelWillOpenAt' },
  openingHoursLabelStatusIsUnknown: {
    defaultMessage: 'No opening hours available',
    id: 'openingHours.labelStatusIsUnknown',
  },
  openingHoursDayClosed: { defaultMessage: 'Closed', id: 'openingHours.dayClosed' },
  openingHoursLabel: { defaultMessage: 'Opening hours', id: 'openingHours.label' },
  ctaLabelRequestTestdrive: {
    defaultMessage: 'Book a test drive',
    id: 'cta.labelRequestTestdrive',
  },
  ctaLabelScheduleService: {
    defaultMessage: 'Request a service appointment',
    id: 'cta.labelScheduleService',
  },
  ctaLabelPbcAnchor: { defaultMessage: 'Overall contact', id: 'cta.labelPbcAnchor' },
  ctaLabelContactUs: { defaultMessage: 'Contact us', id: 'cta.labelContactUs' },
  myAudiLegalDisclaimer: {
    id: 'fa.audi-dealer-search.myAudi_legal_disclaimer',
  },
  myAudiModalSetHeadline: {
    defaultMessage: 'Möchten Sie Ihren Audi Partner ersetzen?',
    id: 'fa.audi-dealer-search.myAudi_modal_set_headline',
  },
  myAudiModalSetCopyText1: {
    defaultMessage:
      'Ihr neu ausgewählter Audi Partner unterscheidet sich von Ihrem aktuellen. Möchten Sie Ihren aktuellen Audi Partner ersetzen oder den neu ausgewählten Audi Partner nur für den aktuellen Vorgang verwenden?',
    id: 'fa.audi-dealer-search.myAudi_modal_set_copy_text1',
  },
  myAudiModalSetCopyText2: {
    defaultMessage:
      'Wenn Sie Ihren Audi Partner ersetzen und damit Ihrem Account zuweisen, erklären Sie sich damit einverstanden, dass dieser zu Support- und Servicezwecken auf Ihre Profildaten zugreifen darf.',
    id: 'fa.audi-dealer-search.myAudi_modal_set_copy_text2',
  },
  myAudiModalSetCta: {
    defaultMessage: 'Ersetzen',
    id: 'fa.audi-dealer-search.myAudi_modal_set_cta',
  },
  myAudiModalNotSetCta: {
    defaultMessage: 'Nicht ersetzen',
    id: 'fa.audi-dealer-search.myAudi_modal_not_set_cta',
  },
  myAudiModalChangeHeadline: {
    defaultMessage: 'Möchten Sie Ihren Audi Partner ersetzen?',
    id: 'fa.audi-dealer-search.myAudi_modal_change_headline',
  },
  myAudiModalChangeCopyText1: {
    defaultMessage:
      'Ihr neu ausgewählter Audi Partner unterscheidet sich von Ihrem aktuellen. Möchten Sie Ihren aktuellen Audi Partner ersetzen oder den neu ausgewählten Audi Partner nur für den aktuellen Vorgang verwenden?',
    id: 'fa.audi-dealer-search.myAudi_modal_change_copy_text1',
  },
  myAudiModalChangeCopyText2: {
    defaultMessage:
      'Wenn Sie Ihren Audi Partner ersetzen und damit Ihrem Account zuweisen, erklären Sie sich damit einverstanden, dass dieser zu Support- und Servicezwecken auf Ihre Profildaten zugreifen darf.',
    id: 'fa.audi-dealer-search.myAudi_modal_change_copy_text2',
  },
  myAudiModalChangeCta: {
    defaultMessage: 'Ersetzen',
    id: 'fa.audi-dealer-search.myAudi_modal_change_cta',
  },
  myAudiModalNotChangeCta: {
    defaultMessage: 'Nicht ersetzen',
    id: 'fa.audi-dealer-search.myAudi_modal_not_change_cta',
  },
};

// TODO: Integrate messages below with the above approach, or vice versa
// export const pbcMessages = {
//   fax: 'partnerBusinessCard.fax',
//   phone: 'partnerBusinessCard.phone',
//   directionsLinkLabel: 'partnerBusinessCard.directionsLinkLabel',
//   vCardLinkLabel: 'partnerBusinessCard.vCardLinkLabel',
//   linkLabel: 'partnerBusinessCard.linkLabel',
//   myAudiLinkLabel: 'partnerBusinessCard.myAudiLinkLabel',
//   addressAndContactLabel: 'partnerBusinessCard.addressAndContact.label',
//   partnerServiceSales: 'service.sales',
//   partnerServiceSalesR8: 'service.sales-r8',
//   partnerServiceService: 'service.service',
//   partnerServiceEtron: 'service.e-tron',
//   partnerServiceUsedcars: 'service.audi-approved-plus',
//   openingHoursHeadline: 'openingHours.headline',
//   openingHoursLabelOpenUntil: 'openingHours.labelOpenUntil',
//   openingHoursLabelClosesSoon: 'openingHours.labelClosesSoon',
//   openingHoursLabelClosed: 'openingHours.labelClosed',
//   openingHoursLabelWillOpenAt: 'openingHours.labelWillOpenAt',
//   openingHoursLabelStatusIsUnknown: 'openingHours.labelStatusIsUnknown',
//   openingHoursDayClosed: 'openingHours.dayClosed',
//   openingHoursLabel: 'openingHours.label',
//   ctaLabelRequestTestdrive: 'cta.labelRequestTestdrive',
//   ctaLabelScheduleService: 'cta.labelScheduleService',
//   ctaLabelPbcAnchor: 'cta.labelPbcAnchor',
//   ctaLabelContactUs: 'cta.labelContactUs',
// };
